function requirePublicConfig(name: string): string {
  const value = process.env[name]?.trim();
  if (!value) {
    throw new Error(`Missing required frontend configuration: ${name}`);
  }
  return value;
}

export const STRIPE_PUBLISHABLE_KEY = requirePublicConfig(
  'REACT_APP_STRIPE_PUBLISHABLE_KEY'
);

export const META_PIXEL_ID = requirePublicConfig(
  'REACT_APP_META_PIXEL_ID'
);
